import { OnboardingStep, UserGender, UserProfile } from "@/generated-api";
import { Button } from "../../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { ArrowLeft, HeartHandshake } from "lucide-react";
import WomenDetailsForm from "@/components/onboarding/data-form/WomenDetailsForm";
import MenDetailsForm from "./MenDetailsForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useState } from "react";
import { useTranslation } from "@/hooks/useTranslation";

export default function UserDetailsForm({
  gender,
  user,
  back,
}: {
  gender: UserGender;
  user: UserProfile;
  back: () => void;
}) {
  const modalOpen = user.re_requested_step === OnboardingStep.FORM;
  const [requestModalOpen, setRequestModalOpen] = useState(modalOpen);
  const t = useTranslation();

  return (
    <>
      <Card className="dark px-2 min-w-[320px] w-full max-w-md mx-auto rounded-3xl border border-zinc-600">
        <CardHeader className="space-y-4 px-4 sm:px-6">
          <Button variant="ghost" className="w-20 px-0" onClick={back}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t.SHARED.LABELS.BACK_BUTTON}
          </Button>
          <CardTitle>{t.USER_FORM.LABELS.TITLE}</CardTitle>
        </CardHeader>
        <CardContent className="px-4 sm:px-6">
          {gender === UserGender.MALE ? (
            <MenDetailsForm user={user} />
          ) : (
            <WomenDetailsForm user={user} />
          )}
        </CardContent>
      </Card>
      <Dialog open={requestModalOpen} onOpenChange={setRequestModalOpen}>
        <DialogContent className="dark text-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex flex-row items-center text-left mb-4">
              <HeartHandshake className="h-5 w-5 mr-2" />
              {t.USER_FORM_ACTION_REQUIRED.LABELS.TITLE}
            </DialogTitle>
            <DialogDescription className="text-left text-md">
              {t.USER_FORM_ACTION_REQUIRED.LABELS.DESCRIPTION}
            </DialogDescription>
            <ul className="list-disc pl-6 space-y-1 pt-2 text-left text-md text-muted-foreground">
              <li>{t.USER_FORM_ACTION_REQUIRED.LABELS.NO_CONTACT_INFO}</li>
              <li>
                {t.USER_FORM_ACTION_REQUIRED.LABELS.NO_OFFENSIVE_LANGUAGE}
              </li>
            </ul>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </>
  );
}
